import React from "react";
import "./Status404.scss";
import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";
import { useLogosAndLinks } from "../../utils/useLogoAndLinks";
import BergButton from "../../components/Storybook/BergButton/BergButton";

const Status404 = () => {
  const { t } = useTranslation("pages");
  const navigate = useNavigate();
  const buildType = process.env.REACT_APP_BUILD_TYPE;
  const {
    logoSrcBrama,
    logoSrcFlisacy,
    logoSrcPolana,
    logoSrcPotok,
    logoSrcStartvelo,
    logoSrcRabkoland,
  } = useLogosAndLinks();

  const logoSrc =
    buildType === 'BRAMA' ? logoSrcBrama :
    buildType === 'FLISACY' ? logoSrcFlisacy :
    buildType === 'POLANA' ? logoSrcPolana :
    buildType === 'POTOK' ? logoSrcPotok :
    buildType === 'STARTVELO' ? logoSrcStartvelo :
    buildType === 'RABKOLAND' ? logoSrcRabkoland :
    null;

  return (
    <>
      <figure className="berg-page-404-figure" />
      {logoSrc && (
        <img
          className="berg-page-404-picture"
          src={logoSrc}
          alt="logo"
        />
      )}
      <p className="berg-page-404-text">{t("status404.text")}</p>
      <BergButton
        color="full"
        label={t("status404.go_to_home_page")}
        onClick={() => navigate("/")}
      />
    </>
  );
};

export default Status404;
